import { SuperAdmin } from '@/plugins/api'
import { upsertMany } from '@/helpers'

export default {
  namespaced: true,
  state: {
    superAdmins: [],
    isLoading: false
  },
  actions: {
    async fetchSuperAdmins({ commit }, options) {
      const res = await SuperAdmin.fetch(options)
      commit('setSuperAdmins', res)
    },
    async fetchSuperAdmin({ commit, state }, { id, options }) {
      const res = await SuperAdmin.fetchOne(id, options)
      commit('setSuperAdmins', upsertMany(state.superAdmins, res))
    },
    async updateSuperAdmin({ commit, state }, { id, params, options }) {
      const res = await SuperAdmin.update(id, params, options)
      commit('setSuperAdmins', upsertMany(state.superAdmins, res))
    },
    async createSuperAdmin({ commit, state }, { params, options }) {
      const res = await SuperAdmin.create(params, options)
      commit('setSuperAdmins', upsertMany(state.superAdmins, res))
    },
    async removeSuperAdmin({ commit, state }, { id, options }) {
      await SuperAdmin.remove(id, options)
      commit(
        'setSuperAdmins',
        state.superAdmins.filter(i => i.id !== id)
      )
    },
    async swapSuperAdmin({ commit, state }, { id, params, options }) {
      await SuperAdmin.swap(id, params, options)
      commit(
        'setSuperAdmins',
        state.superAdmins.filter(i => i.id !== id)
      )
    }
  },
  mutations: {
    setSuperAdmins(state, v) {
      state.superAdmins = v
    }
  }
}
